import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import CustomButton from "../../../../Components/Button/CustomButton";
import CustomInput from "../../../../Components/input/CustomInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { GetSingleService } from "../../../../APIs/Function/HomePageLinks/Services/GetSingleService";
import { handleUpdateService } from "../../../../APIs/Function/HomePageLinks/Services/EditService";

const EditService = () => {
  const [imagePreview, setImagePreview] = useState(null);
  const [iconPreview, setIconPreview] = useState(null);
  const [serviceData, setServiceData] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    description: Yup.string().required("Description is required"),
    link: Yup.string().required("Link is required"),
    file: Yup.mixed().required("Image is required"),
  });

  const handlePageService = async () => {
    setLoading(true);
    try {
      let res = await GetSingleService(id);
      setLoading(false);
      setServiceData(res.r[0]);
      setFormData({
        ...formData,
        name: res.r.name,
        link: res.r.link,
        description: res.r.description,
        icon: res.r.icon,
        file: res.r.photo,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handlePageService();
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    link: "",
    icon: null,
    file: null,
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    console.log(formData);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const dataURL = URL.createObjectURL(file);
    setImagePreview(dataURL);
    setFormData({
      ...formData,
      file: file,
    });
  };

  const handleIconChange = (event) => {
    const icon = event.target.files[0];
    const dataURL = URL.createObjectURL(icon);
    setIconPreview(dataURL);
    setFormData({
      ...formData,
      icon: icon,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedFormData = {
      name: formData.name.trim(),
      description: formData.description.trim(),
      link: formData.link.trim(),
      file: formData.file,
      icon: formData.icon,
    };

    const isValid = await validationSchema.isValid(trimmedFormData);

    if (!isValid) {
      alert("Please fill all required fields correctly");
      return;
    }

    if (!formData.file) {
      alert("Please select an image");
      return;
    }
    if (!formData.icon) {
      alert("Please select an icon");
      return;
    }

    setLoading(true);

    try {
      await handleUpdateService({ id, ...formData });
      setLoading(false);
      alert("Data Edited Successfully");
      navigate("/pagelinks");
    } catch (error) {
      console.error(error);
      setLoading(false);
      alert("An error occurred while updating the data.");
    }
  };

  return (
    <>
      {" "}
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          {/* header */}
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/pagelinks"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  width={"100%"}
                  height={"100%"}
                  src={backbluebtn}
                  alt="back"
                />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Edit Details
              </Typography>
            </Box>
            <Box>
              <CustomButton
                sx={{
                  width: { xs: "40px", md: "50px", lg: "80px" },
                  height: { xs: "10px", md: "50px", lg: "50px " },
                }}
                onClick={handleSubmit}
              >
                {loading ? <CircularProgress></CircularProgress> : "Save"}
              </CustomButton>
            </Box>
          </Box>
          {/* form */}
          <Container maxWidth="sm" sx={{ mt: "30px" }}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={{ textAlign: "left" }}>
                  <label htmlFor="name">Name</label>
                  <CustomInput
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sx={{ textAlign: "left" }}>
                  <label htmlFor="description">Description</label>
                  <CustomInput
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    fullWidth
                    multiline
                    rows={4}
                    required
                  />
                </Grid>
                <Grid item xs={12} sx={{ textAlign: "left" }}>
                  <label htmlFor="link">Link</label>
                  <CustomInput
                    name="link"
                    value={formData.link}
                    onChange={handleInputChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <label htmlFor="file-input">
                    <Box
                      sx={{
                        width: "100%",
                        bgcolor: "#F4F4F4",
                        p: "20px",
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center ",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Box>
                        <Typography>Update Image</Typography>
                        <Box
                          sx={{
                            width: "25%",
                            height: "25%",
                            m: "auto",
                            mt: "5px",
                          }}
                        >
                          <Box sx={{ width: "50px", height: "50px" }}>
                            <img
                              width={"100%"}
                              hieght={"100%"}
                              src={
                                imagePreview
                                  ? imagePreview
                                  : `https://api-qhealth.equitysofttechnologies.com/upload/images/${formData.file}`
                              }
                              alt="preview"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </label>
                  <input
                    accept="image/*"
                    type="file"
                    id="file-input"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <label htmlFor="file-icon">
                    <Box
                      sx={{
                        width: "100%",
                        bgcolor: "#F4F4F4",
                        p: "20px",
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center ",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Box>
                        <Typography>Update Icon</Typography>
                        <Box
                          sx={{
                            width: "50px",
                            height: "50px",
                            m: "auto",
                            mt: "5px",
                          }}
                        >
                          <img
                            width={"100%"}
                            hieght={"100%"}
                            src={
                              iconPreview
                                ? iconPreview
                                : `https://api-qhealth.equitysofttechnologies.com/upload/images/${formData.icon}`
                            }
                            alt="preview"
                          />
                        </Box>
                      </Box>
                    </Box>
                  </label>
                  <input
                    accept="image/*"
                    type="file"
                    id="file-icon"
                    onChange={handleIconChange}
                    style={{ display: "none" }}
                  />
                </Grid>
              </Grid>
            </form>
          </Container>
        </Box>
      )}
    </>
  );
};

export default EditService;
